import React from 'react';

import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  Stack, BodyText, Button, HeaderText,
} from '../../../../../ui';
import Stars from '../../../../../../../images/animations/stars.svg';
import SVGatorAnimation from '../../../../../ui/SVGatorAnimation';

import Title from '../../Title';

type EarningProps = {
  daysLeft: number;
  appearances?: number;
  cta: {
    text: string;
    onClick: () => void;
  };
  preview?: () => void;
};
const Earning: React.FC<EarningProps> = ({
  daysLeft,
  cta,
  preview,
  appearances,
}) => (
  <Stack justifyContent="center" alignItems="center">
    <Title modeText="ACTIVE" />
    <Box
      justifyContent="center"
      alignItems="center"
      style={{ height: 100, width: '100%' }}
    >
      <SVGatorAnimation
        source={{ uri: Stars, width: 325, height: 100 }}
        style={{
          position: 'absolute',
          top: -20,
          left: '47%',
          transform: 'translate(-50%)',
        }}
      />
      <Stack alignItems="center">
        <HeaderText
          level={1}
          color={colors.slate}
          testID="search-boost-active-value"
        >
          {appearances >= 25 ? appearances : daysLeft}
        </HeaderText>
        <BodyText
          appearance="small"
          color={colors.slate}
          weight="bold"
          testID="search-boost-active-label"
        >
          {appearances >= 25 ? 'Search Appearances' : 'Days Left'}
        </BodyText>
      </Stack>
      {appearances >= 25 && (
        <BodyText
          style={{
            backgroundColor: colors.punch,
            position: 'absolute',
            top: 34,
            right: -16,
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 8,
            paddingRight: 8,
          }}
          color={colors.whiteWash}
          appearance="legal"
          testID="search-boost-active-days"
        >
          {daysLeft} days left
        </BodyText>
      )}
    </Box>
    <BodyText appearance="small" textAlign="center">
      Your profile is being pushed to the top of client searches in your area.
      The more traffic you get now, the higher up you’ll appear in future client searches.
    </BodyText>
    <Stack paddingTop={20} space={12}>
      <Button
        size="medium"
        appearance="chill"
        onClick={cta.onClick}
        testID="search-boost-active-cta"
      >
        {cta.text}
      </Button>
      {preview && (
        <Button appearance="link" testID="search-boost-active-preview" onClick={preview}>preview search</Button>
      )}
    </Stack>
  </Stack>
);

export default Earning;
